<div class="wrapper flex flex-col">
  <div class="heading mb-[24px] flex flex-row justify-between items-center">
    <div class="counter text-type-2">
      {{ editing ? 'Edit Signature' : 'Add Signature' }}
    </div>
    <mat-icon (click)="close()">close</mat-icon>
  </div>

  <div class="flex flex-row w-full mb-[20px]">
    <app-dropdown
      [options]="roleOptions"
      [parentFormGroup]="localForm"
      class="w-full"
      controlName="role"
      label="role"
      placeholder="Select"
    />
  </div>

  <!-- TYPED mode (signaturePadEnabled=false): a single text input labeled
       "signature" bound to the printedName control. No asterisk; the confirm
       gate (role + non-empty text) lives in confirmDisabled. -->
  <div *ngIf="!signaturePadEnabled" class="flex flex-row w-full mb-[20px]">
    <app-text-input
      [parentFormGroup]="localForm"
      class="w-full"
      controlName="printedName"
      label="signature"
      placeholder="Enter signature"
      [maxLength]="120"
    />
  </div>

  <!-- DRAW-PAD mode (signaturePadEnabled=true): printed name + canvas. -->
  <!-- Printed name: a legible typed name captured ABOVE the draw pad and emitted
       as the signature's signature_text. Mandatory when the form's
       ui_config.signature_pad.require_printed_name is on (requirePrintedName). -->
  <div *ngIf="signaturePadEnabled" class="flex flex-row w-full mb-[20px]">
    <app-text-input
      [parentFormGroup]="localForm"
      class="w-full"
      controlName="printedName"
      [label]="requirePrintedName ? 'printed name *' : 'printed name'"
      placeholder="Enter printed name"
      [maxLength]="120"
    />
  </div>

  <!-- Single signature pad. In edit mode the existing signature is shown as a
       plain <img> overlay filling the pad area (NOT drawn onto the canvas), so it
       is guaranteed to display with no fetch/base64/canvas drawing. The canvas
       sits ON TOP (transparent) to capture NEW strokes. The overlay is hidden as
       soon as the user starts drawing (userDrew) or hits Clear, so a fresh
       re-sign shows only the new strokes. Confirming without a new stroke keeps
       the existing signature. -->
  <!-- Draw pad: img overlay (edit) + canvas with signature line + Clear -->
  <div *ngIf="signaturePadEnabled" class="draw-section mb-[24px]">
    <div class="canvas-wrap">
      <img
        *ngIf="editing && existingImageUrl && !userDrew && !cleared"
        class="existing-signature-overlay"
        [src]="existingImageUrl"
        alt="Existing signature"
      />
      <canvas
        #signatureCanvas
        class="signature-canvas"
        (pointerdown)="onPointerDown($event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp()"
        (pointerleave)="onPointerUp()"
      ></canvas>
      <div class="signature-line"></div>
      <span *ngIf="!hasDrawing && !userDrew && (!editing || cleared)" class="canvas-hint">Sign above the line</span>
    </div>
    <div class="flex flex-row justify-end mt-[8px]">
      <button type="button" class="clear-btn" (click)="clearCanvas()">Clear</button>
    </div>
  </div>

  <div class="actions flex flex-row justify-end">
    <app-primary-button
      [isDisabled]="confirmDisabled"
      [isLoading]="uploading"
      (handleClick)="add()"
    >
      {{ editing ? 'Save' : 'Add' }}
    </app-primary-button>
  </div>
</div>
